export default __webpack_public_path__ + "static/media/kriyago_logo.26dfe132.png";